module.exports = __webpack_public_path__ + "static/media/filter.0f91a481.svg";